import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { CardReward } from '#src/components/so5/LastFixtureStory/CardRewardsReveal/CardReward/index.tsx';
import { CardShardsReward } from '#src/components/so5/LastFixtureStory/CardRewardsReveal/CardShardsReward/index.tsx';
import { MonetaryReward } from '#src/components/so5/LastFixtureStory/CardRewardsReveal/MonetaryReward/index.tsx';

import type {
  RevealableReward_anyRewardConfigInterface,
  RevealableReward_so5Reward,
} from './__generated__/index.graphql.ts';

type Props = {
  so5Reward: RevealableReward_so5Reward;
  rewardConfig?: RevealableReward_anyRewardConfigInterface | null;
  leaguePictureUrl: string;
  onReveal?: () => void;
  revealed?: boolean;
};
export const RevealableReward = ({
  so5Reward,
  rewardConfig,
  leaguePictureUrl,
  onReveal,
  revealed,
}: Props) => {
  if (isType(rewardConfig, 'CardRewardConfig')) {
    return (
      <CardReward
        key={so5Reward.slug}
        so5Reward={so5Reward}
        leaguePictureUrl={leaguePictureUrl}
        onReveal={onReveal}
      />
    );
  }
  if (isType(rewardConfig, 'MonetaryRewardConfig')) {
    return (
      <MonetaryReward
        key={so5Reward.slug}
        so5Reward={so5Reward}
        monetaryRewardConfig={rewardConfig}
        leaguePictureUrl={leaguePictureUrl}
        onReveal={onReveal}
        revealed={revealed}
      />
    );
  }
  if (isType(rewardConfig, 'CardShardRewardConfig')) {
    return (
      <CardShardsReward
        key={so5Reward.slug}
        so5Reward={so5Reward}
        cardShardsConfig={rewardConfig}
        leaguePictureUrl={leaguePictureUrl}
        onReveal={onReveal}
        revealed={revealed}
      />
    );
  }
  return null;
};

RevealableReward.fragments = {
  anyRewardConfigInterface: gql`
    fragment RevealableReward_anyRewardConfigInterface on AnyRewardConfigInterface {
      id
      ...MonetaryReward_anyRewardConfigInterface
      ...CardShardsReward_anyRewardConfigInterface
    }
    ${MonetaryReward.fragments.anyRewardConfigInterface}
    ${CardShardsReward.fragments.anyRewardConfigInterface}
  ` as TypedDocumentNode<RevealableReward_anyRewardConfigInterface>,
  so5Reward: gql`
    fragment RevealableReward_so5Reward on So5Reward {
      slug
      ...CardRewardWithRewardChoices_so5Reward
      ...MonetaryReward_so5Reward
      ...CardShardsReward_so5Reward
    }
    ${MonetaryReward.fragments.anyRewardConfigInterface}
    ${CardReward.fragments.so5Reward}
    ${MonetaryReward.fragments.so5Reward}
    ${CardShardsReward.fragments.so5Reward}
  ` as TypedDocumentNode<RevealableReward_so5Reward>,
};
